import Vue from 'vue'
import axios from "axios";
import {ActionTree, MutationTree} from 'vuex'
import {RootState} from '@/store/types'

import {IContactBlock} from "@/store/modules/lib";
import api from "@/service/api";
import VueI18n from "@/helpers/i18n";

export interface State {
    contacts: IContactBlock[]
    contactFields: any
    isLoaded: boolean,
    errorMessage: string,
    isError: boolean
}

const defaultState: State = {
    contacts: [],
    contactFields: null,
    isLoaded: false,
    errorMessage: '',
    isError: false
}

const getters = {
    contacts: (state: State) => state.contacts,
    contactFields: (state: State) => state.contactFields,
    loading: (state: State) => state.isLoaded,
    error: (state: State) => ({text: state.errorMessage, showError: state.isError}),
}

const mutations: MutationTree<State> = {
    setLoading: (state: State, payload: boolean) => state.isLoaded = payload,
    setError: (state: State, payload: string) => {
        state.errorMessage = payload
        state.isError = true
        setTimeout(() => state.isError = false, 5000)
    },
    setContactFields: (state: State, payload: any) => state.contactFields = payload,
}

const actions: ActionTree<State, RootState> = {
    async fetchContacts({commit, state}, payload) {
        commit('setLoading', true)
        try {
            const {data} = await
                api.go('fetchContacts', {
                    params: payload.params
                })
            state.contacts = data.data.map((contact: any) => {
                return {...contact, isEditing: false}
            })
        } catch (e) {
            // @TODO обработка ошибки
        } finally {
            commit('setLoading', false)
        }
    },
    async fetchFieldsList({commit, state}, payload) {
        // if(state.contactFields == null) {
            commit('setLoading', true)
            try {
                const {data} = await api.go('fetchFieldsList', {
                params: payload.params
                })
                state.contactFields = data.data
            } catch (e) {
                // @TODO обработка ошибки
            } finally {
                commit('setLoading', false)
            }
        // }
    },
    async patchContacts({commit, state}, payload) {
        commit('setLoading', true)
        try {
            const normalizedContacts = payload.contacts.map((contact: any) => {
                delete contact.isEditing
                return contact
            })
            await api.go('patchContacts', {
                params: payload.params,
                body:normalizedContacts
            })
            this.commit('alerts/setAlert', {
                show: true,
                messages: [VueI18n.t('error.some_notification.data_save')]
            })
            return true
        } catch (e) {
            // @TODO обработка ошибки
            return false
        } finally {
            commit('setLoading', false)
        }
    }
}

export default {
    namespaced: true,
    state: defaultState,
    getters,
    mutations,
    actions
}
